var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"text":_vm.title,"variant":"transparent","toggle-class":"btn-block-option"}},[_vm._t("items")],2)}
var staticRenderFns = []

export { render, staticRenderFns }